import React, { Component } from "react";
import { connect } from "react-redux";
import PantallaCarga from "../mensajeFlash/PantallaCarga";
import {
  Button,
  Container,
  Row,
  Col,
  Modal,
  Form,
  Table,
} from "react-bootstrap";
import { getUsuario } from "../usuario/UsuarioService";
import { idEmpresa } from "../../constans/constants";
import {
  registrarGrupo,
  editarGrupo,
  eliminarGrupo,
} from "../usuario/UsuarioService";
import delete_forever from "../../styles/icons/delete.svg";
import add_circle from "../../styles/icons/add_circle.svg";
import search from "../../styles/icons/search.svg";

class GrupoUsuario extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      descripcion: "",
      activo: true,
      id: "",
      usuarios: [],
      mensaje: "",
      severity: "",
      usuariosAux: [],
      openPantallaCarga: false,
      validated: false,
      pageSize: 5,
      search: ""
    };
    this.tableRef = React.createRef();
  }

  handleClose = () => {
    this.props.handleClose(false, this.state.mensaje, this.state.severity);
  };

  handleChange = (event) => {
    this.setState({ ...this.state, [event.target.name]: event.target.checked });
  };

  handleAplicacionExternaSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      this.setState({ validated: true });
    } else {
      this.setState({ openPantallaCarga: true });
      if (this.props.type === "edit") {
        const json = {
          descripcion: this.state.descripcion,
          activo: this.state.activo,
          id: this.state.id,
          usuarios: this.state.usuariosAux,
          idEmpresa: idEmpresa(),
        };
        this.props.editarGrupo(json).then((response) => {
          if (response.error) {
            this.setState({ mensaje: response.mensaje });
            this.setState({ severity: "danger" });
          } else {
            this.setState({ mensaje: response.mensaje });
            this.setState({ severity: "success" });
          }
          this.handleClose();
        });
      } else if (this.props.type === "add") {
        const json = {
          descripcion: this.state.descripcion,
          activo: this.state.activo,
          usuarios: this.state.usuariosAux,
          idEmpresa: idEmpresa(),
        };
        this.props.registrarGrupo(json).then((response) => {
          if (response.error) {
            this.setState({ mensaje: response.mensaje });
            this.setState({ severity: "danger" });
          } else {
            this.setState({ mensaje: response.mensaje });
            this.setState({ severity: "success" });
          }
          this.handleClose();
        });
      }
    }
  };
  agregarUsuario(usuariosData) {
    var usuarioAuxA = this.state.usuariosAux;
    usuariosData.map((elemento) => {
      if (!usuarioAuxA.some((elementoAux) => elementoAux.id === elemento.id)) {
        usuarioAuxA.push(elemento);
      }
    });
    this.setState({ usuariosAux: usuarioAuxA });
  }

  eliminarUsuario(usuariosData) {
    var usuarioAuxA = this.state.usuariosAux;
    usuariosData.map((elemento) => {
      usuarioAuxA = usuarioAuxA.filter(
        (elementoAux) => elementoAux.id != elemento.id
      );
    });
    this.setState({ usuariosAux: usuarioAuxA });
  }
  componentDidMount() {
    if (this.props.type === "edit") {
      this.setState({
        descripcion: this.props.grupo.descripcion,
        activo: this.props.grupo.activo,
        id: this.props.grupo.id,
        usuariosAux: this.props.grupo.miembros,
      });
    }
    this.fetchUsuarios(0, this.state.pageSize, ""); // Página inicial, tamaño y búsqueda vacía
  }

  handleInput = (e) => {
    var name = e.target.name;
    var val = e.target.value;
    this.setState({
      [name]: val,
    });
  };

  handlePageSizeChange(event) {
    const pageSize = parseInt(event.target.value, 10);
    this.setState({ pageSize, page: 0 }, () => {
      this.fetchUsuarios();
    });
  }

  handlePageChange(newPage) {
    if (newPage >= 0 && newPage < this.state.totalPages) {
      this.setState({ page: newPage }, () => {
        this.fetchUsuarios(newPage, this.state.pageSize, "");
      });
    }
  }

  handlePageChange = (newPage) => {
    if (newPage >= 0 && newPage < this.state.totalPages) {
      this.setState({ page: newPage }, () => {
        this.fetchUsuarios(this.state.page, this.state.pageSize, "");
      });
    }
  };

  handlePageSizeChange = (event) => {
    const newPageSize = parseInt(event.target.value, 10);
    this.setState({ pageSize: newPageSize, page: 0 }, () => {
      this.fetchUsuarios(this.state.page, this.state.pageSize, "");
    });
  };

  renderPageNumbers() {
    const { page, totalPages } = this.state;
    const maxVisiblePages = 5; // Máximo de páginas visibles

    let pages = [];

    if (totalPages <= maxVisiblePages) {
      // Mostrar todas las páginas si son pocas
      for (let i = 0; i < totalPages; i++) {
        pages.push(
          <li
            key={i}
            className={`page-item ${page === i ? "active" : ""}`}
            onClick={() => this.handlePageChange(i)}
          >
            <a className="page-link" type="Button">{i + 1}</a>
          </li>
        );
      }
    } else {
      // Mostrar primeras páginas, últimas y cercanas a la actual
      const startPage = Math.max(0, page - 2);
      const endPage = Math.min(totalPages - 1, page + 2);

      // Agregar primera página
      if (startPage > 0) {
        pages.push(
          <li
            key={0}
            className={`page-item ${page === 0 ? "active" : ""}`}
            onClick={() => this.handlePageChange(0)}
          >
            <a className="page-link" type="Button">1</a>
          </li>
        );
        if (startPage > 1) {
          pages.push(
            <li key="start-ellipsis" className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          );
        }
      }

      // Agregar páginas visibles
      for (let i = startPage; i <= endPage; i++) {
        pages.push(
          <li
            key={i}
            className={`page-item ${page === i ? "active" : ""}`}
            onClick={() => this.handlePageChange(i)}
          >
            <a className="page-link" type="Button">{i + 1}</a>
          </li>
        );
      }

      // Agregar última página
      if (endPage < totalPages - 1) {
        if (endPage < totalPages - 2) {
          pages.push(
            <li key="end-ellipsis" className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          );
        }
        pages.push(
          <li
            key={totalPages - 1}
            className={`page-item ${page === totalPages - 1 ? "active" : ""}`}
            onClick={() => this.handlePageChange(totalPages - 1)}
          >
            <a className="page-link" type="Button">{totalPages}</a>
          </li>
        );
      }
    }

    return pages;
  }

  fetchUsuarios(page, pageSize, search) {
    this.setState({ loading: true });
    this.props.getUsuario(page, pageSize, search).then(() => {
      this.setState({
        lotes: this.props.usuariosData.usuarios,
        page: this.props.usuariosData.page,
        totalCount: this.props.usuariosData.totalCount,
        totalPages: Math.ceil(this.props.usuariosData.totalCount / pageSize),
        loading: false 
      });
    });
  }
  
  handleSearchChange = (e) => {
    const searchValue = e.target.value;
    this.setState({ search: searchValue }, () => {
      this.fetchUsuarios(0, this.state.pageSize, this.state.search);
    });
  };


  render() {
    return (
      <Container fluid>
        <Form
          ref="form"
          noValidate
          validated={this.state.validated}
          onSubmit={this.handleAplicacionExternaSubmit}
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ color: "#0c56d0" }}>
              {" "}
              {this.props.dialogTitle}{" "}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col xs={6} style={{ padding: "10px" }}>
                <p className="form-date" style={{ paddingBottom: "10px" }}>
                  {" "}
                  <h5>
                    <strong>Datos del Grupos</strong>
                  </h5>
                </p>
                <Form.Group className="form-group md-input">
                  <div className="form-group md-input">
                    <input
                      className="form-control md-form-control"
                      type="text"
                      name="descripcion"
                      id="descripcion"
                      placeholder=" "
                      onChange={this.handleInput}
                      value={this.state.descripcion}
                      required
                    />
                    <Form.Label class="md-label"> Descripción </Form.Label>
                    <Form.Control.Feedback type="invalid">
                      <small>Campo requerido</small>
                    </Form.Control.Feedback>
                  </div>
                </Form.Group>
                {/* {(this.props.type === "add")?<Row>
                <Col>                  
                <Form.Group className="form-group md-input"  style={{ marginBottom: '35px' }}>
                    <Form.Check
                      type="switch"
                      id="estadoGrupo"
                      checked={this.state.activo}
                      onChange={this.handleChange}
                      name="activo"
                      label="Activo"
                    />
                  </Form.Group>
                  </Col>
            </Row>:null} */}
                <Row>
                  <Col>
                    <div style={{ overflow: "auto", height: "300px" }}>
                      <Table striped bordered hover size="sm" responsive="md">
                        <thead>
                          <tr>
                            <th>Nombre Y Apellido</th>
                            <th>Usuario</th>
                            <th>C.I.</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.usuariosAux.map((elemento) => (
                            <tr key={elemento.nombre}>
                              <td component="th" scope="row">
                                {elemento.nombreApellido}
                              </td>
                              <td>{elemento.usuario}</td>
                              <td>{elemento.cedula}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col xs={6} style={{ padding: "10px" }}>
                <p className="form-date">
                  {" "}
                  <h5>
                    <strong>Usuarios</strong>
                  </h5>
                </p>
                <div className="contentBuscador card">
              <form className="searchForm">
                <div className="input-group input-group-lg">
                  <span className="input-group-text border-0" id="basic-addon2">
                    <img src={search} />
                  </span>
                  <input
                    type="search"
                    className="form-control"
                    placeholder="Buscar.."
                    aria-label="Search"
                    aria-describedby="basic-addon2"
                    value={this.state.search}
                    onChange={this.handleSearchChange}
                  />
                </div>
              </form>
            </div>
                <table className="table table-striped table-hover">
                  <thead>
                    <tr>
                      <th scope="col">Nombres y Apellidos</th>
                      <th scope="col">Usuario</th>
                      <th scope="col">C.I.</th>
                      <th scope="col">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.usuariosData.usuarios.map((usuario, index) => (
                      <tr key={index}>
                        <td>{usuario.nombreApellido}</td>
                        <td>{usuario.usuario}</td>
                        <td>{usuario.cedula}</td>
                        <td>
                          <div className="table-actions">
                            <button
                              className="btn btn-secondary btn-md btn-floating"
                              onClick={() => this.agregarUsuario([usuario])}
                              title="Agregar al Grupo"
                              type="button"
                            >
                              <img src={add_circle} alt="Agregar" />
                            </button>
                            <button
                              className="btn btn-secondary btn-md btn-floating"
                              onClick={() => this.eliminarUsuario([usuario])}
                              title="Eliminar del Grupo"
                              type="button"
                            >
                              <img src={delete_forever} alt="Eliminar" />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div id="paginador">
                    <label>
                      Mostrar
                      <select
                        className="form-control custom-select"
                        id="maxRows"
                        name="state"
                        value={this.state.pageSize}
                        onChange={this.handlePageSizeChange}
                      >
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="50">50</option>
                      </select>
                      resultados.
                    </label>
                    <ul className="pagination mb-0">
                      <li
                        className={`page-item ${
                          this.state.page === 0 ? "disabled" : ""
                        }`}
                        onClick={() =>
                          this.handlePageChange(this.state.page - 1)
                        }
                      >
                        <a className="page-link" type="Button">
                          <span className="material-icons">chevron_left</span>
                        </a>
                      </li>
                      {this.renderPageNumbers()}
                      <li
                        className={`page-item ${
                          this.state.page === this.state.totalPages - 1
                            ? "disabled"
                            : ""
                        }`}
                        onClick={() =>
                          this.handlePageChange(this.state.page + 1)
                        }
                      >
                        <a className="page-link" type="Button">
                          <span className="material-icons">chevron_right</span>
                        </a>
                      </li>
                    </ul>
                  </div>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={this.handleClose}
              variant="contained"
              color="primary"
            >
              Cancelar
            </Button>
            <Button autoFocus color="primary" type="submit">
              {this.props.submitText}
            </Button>
          </Modal.Footer>
        </Form>
        <PantallaCarga open={this.state.openPantallaCarga} />
      </Container>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  registrarGrupo: (value) => dispatch(registrarGrupo(value)),
  editarGrupo: (value) => dispatch(editarGrupo(value)),
  getUsuario: (page, size, search) => dispatch(getUsuario(page, size, search)),
});

const mapStateToProps = (state) => ({
  usuariosData: state.usuariosData,
});

export default connect(mapStateToProps, mapDispatchToProps)(GrupoUsuario);
